// extracted by mini-css-extract-plugin
export default {"container":"o0YiMAP8","wrapper":"B1_vmNNd","buttons":"oUKLixL4","windowsButton":"Pgysk0gP","applicationName":"F4gGoZNE","windowsButtons":"hKXvGlWy"};